import { BASE_URL } from "../../config/config";
import { builder } from "../../utils/queryBuilder";
import Fetch from "../Fetch";

export const createOrderByCustomer = async (body) =>
  await Fetch.post(`${BASE_URL}order/user`, body);

export const getAllCustomerOrder = (body) => {
  const params = builder({
    take: body.take,
    skip: body.skip,
  });
  return Fetch.get(`${BASE_URL}order/user${params}`);
};

export const getACutomerOrder = (id) =>
  Fetch.get(`${BASE_URL}order/user/${id}`);

export const updateCustomerOrder = (id, body) =>
  Fetch.patch(`${BASE_URL}order/user/${id}`, JSON.stringify(body), {
    headers: {
      "Content-Type": "application/json",
    },
  });


export const deleteCustomerOrder = (id) =>
  Fetch.delete(`${BASE_URL}order/user/${id}`);
